const insertArrayAt = (array, index, arrayToInsert) => {
  Array.prototype.splice.apply(array, [index, 0].concat(arrayToInsert))
  return array
}

export default insertArrayAt
